import React, { useEffect} from "react";
import { connect } from "react-redux";
import AppraiserQueue from "./AppraiserQueue";
import { updateHeader, clearHeader } from "actions/layout";

interface RouteParams {
  appraiserId: string;
}
interface RouteMatch {
  params: RouteParams;
}
interface RouteHistory {
  goBack: () => void;
}
interface Props {
  match: RouteMatch; // from router
  history: RouteHistory; // from router
  updateHeader: (any) => void;
  clearHeader: () => void;
}
const AppraiserQueueRoute = ({
  match,
  history,
  updateHeader,
  clearHeader,
} : Props) => {

  useEffect(() => {
    updateHeader({
      buttons: [{
        name: "Go Back",
        onClick: () => history.goBack(),
      }]
    });

    return () => {
      clearHeader();
    };
  }, []);

  const id = parseInt(match.params.appraiserId);

  return (
    <AppraiserQueue appraiserId={id} />
  );
};

const mapDispatchToProps = dispatch => ({
  updateHeader(headerDefinitions) {
    dispatch(updateHeader(headerDefinitions));
  },
  clearHeader() {
    dispatch(clearHeader());
  },
});

export default connect(null, mapDispatchToProps)(AppraiserQueueRoute);